import React from 'react';
import {formatDriverCurrency,confirmedCashRemaining} from '../../utils/driverMoney';
export default function DriverPaymentDetails({order}) {
 const method={UPI:'UPI',CARD:'Credit card',DEBIT:'Debit card',CASH:'Cash on delivery',COD:'Cash on delivery',CASH_ON_DELIVERY:'Cash on delivery'}[String(order?.paymentMethod||'').toUpperCase()];
 const cash=confirmedCashRemaining(order);
 return <section className="my-2" aria-label="Customer payment allocation">
  <p className="mb-1">Payment method: {method||'Unavailable'}</p>
  <p className="mb-1">{typeof order?.paymentStatus==='string'&&order.paymentStatus.trim()?'Payment status: '+order.paymentStatus:'Payment status unavailable'}</p>
  {cash===undefined?<p>Cash remaining unavailable. Confirm the server payment allocation before collecting cash.</p>:<>
   <p>Customer fare: {formatDriverCurrency(order.finalFare)}</p>
   <p>Wallet contribution: {formatDriverCurrency(order.walletPaid)}. Online contribution: {formatDriverCurrency(order.onlinePaid)}.</p>
   <p><strong>Cash remaining: {formatDriverCurrency(cash)}</strong></p>
   {Number.isSafeInteger(order.cashPaid)&&order.cashPaid>0&&<p>Cash received: {formatDriverCurrency(order.cashPaid)}</p>}
  </>}
  <p className="small">Payment to a driver's personal UPI account is not a platform-verified payment. Customer fare and payment status do not establish driver earnings or a payout.</p>
 </section>;
}
